import { api } from '../utils/api';

/**
 * Attorney self-profile for document signature blocks.
 *
 * GET /api/v1/attorney-profile/me returns the persisted letterhead identity.
 * PATCH persists name, email, and bar_number. The backend defaults email to the
 * Clerk identity when the record has none.
 */
export interface AttorneyProfile {
  clerk_user_id: string;
  name: string;
  email: string;
  bar_number: string;
  profile_completed: boolean;
}

export interface AttorneyProfilePayload {
  name?: string;
  email?: string;
  bar_number?: string;
}

export interface SaveAttorneyProfileResponse {
  success: boolean;
  saved: AttorneyProfile;
}

/**
 * Fetch the current user's attorney profile.
 *
 * `showErrorToast: false` because the component handles the empty-state (404)
 * itself and should not flash an error on first run.
 */
export async function getAttorneyProfile(): Promise<AttorneyProfile | null> {
  try {
    const res = await api.get<AttorneyProfile>('/api/v1/attorney-profile/me', {
      showErrorToast: false,
    });
    return res;
  } catch {
    return null;
  }
}

/**
 * Persist letterhead fields. Sending empty strings is allowed — the backend
 * accepts them and the document-generation gate blocks later when bar_number
 * is missing.
 */
export async function saveAttorneyProfile(
  payload: AttorneyProfilePayload,
): Promise<SaveAttorneyProfileResponse> {
  return api.patch<SaveAttorneyProfileResponse>(
    '/api/v1/attorney-profile/me',
    payload,
  );
}

export default getAttorneyProfile;
